import { CommonModule, registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { IonicSelectableModule } from 'ionic-selectable';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { es_ES, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NzTimelineModule } from 'ng-zorro-antd/timeline';
import { QuicklinkModule } from 'ngx-quicklink';

import { ErrorMessagesComponent } from './features/error-messages/error-messages.component';
import { HeaderCloseSessionComponent } from './headers/header-close-session/header-close-session.component';
import { HeaderNotButtonsComponent } from './headers/header-not-buttons/header-not-buttons.component';
import { HeaderComponent } from './headers/header/header.component';
import { MenuComponent } from './menu/menu.component';
import { GatherHistoryComponent } from './request-history/gather-history/gather-history.component';
import { KitHistoryComponent } from './request-history/kit-history/kit-history.component';
import { SampleHistoryComponent } from './request-history/sample-history/sample-history.component';
import { BtnSupportComponent } from './utils/btn-support/btn-support.component';
import { SubTitleComponent } from './utils/sub-titles/sub-title/sub-title.component';
import { TitleFourComponent } from './utils/titles/title-four/title-four.component';
import { TitleThreeComponent } from './utils/titles/title-three/title-three.component';
import { TitleTwoComponent } from './utils/titles/title-two/title-two.component';
import { TitleComponent } from './utils/titles/title/title.component';
import { NotificationsComponent } from './features/notifications/notifications.component';
import { IonicStorageModule } from '@ionic/storage-angular';
import { FiltersComponent } from './features/filters/filters.component';
registerLocaleData(es)

@NgModule({
  declarations: [
    HeaderComponent,
    HeaderCloseSessionComponent,
    HeaderNotButtonsComponent,
    GatherHistoryComponent,
    SampleHistoryComponent,
    KitHistoryComponent,
    TitleComponent,
    TitleTwoComponent,
    TitleThreeComponent,
    TitleFourComponent,
    SubTitleComponent,
    MenuComponent,
    ErrorMessagesComponent,
    BtnSupportComponent,
    NotificationsComponent,
    FiltersComponent
  ],
  exports: [
    HeaderComponent,
    HeaderCloseSessionComponent,
    HeaderNotButtonsComponent,
    GatherHistoryComponent,
    SampleHistoryComponent,
    KitHistoryComponent,
    TitleComponent,
    TitleTwoComponent,
    TitleThreeComponent,
    TitleFourComponent,
    SubTitleComponent,
    MenuComponent,
    ErrorMessagesComponent,
    BtnSupportComponent,
    NotificationsComponent,
    FiltersComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    QuicklinkModule,
    NzDatePickerModule,
    NzTimelineModule,
    NzAutocompleteModule,
    IonicSelectableModule,
    TranslateModule,
  ],
  providers: [{ provide: NZ_I18N, useValue: es_ES }, ]
})
export class ComponentsModule {}
